import { ExclamationMarkCircleBold, ExclamationMarkTriangleBold } from '@pretto/picto'

import PropTypes from 'prop-types'
import { ThemeProvider } from 'styled-components'

import * as S from './styles'

const DELIMITER = ' / '
const PLACEHOLDER = `JJ${DELIMITER}MM${DELIMITER}AAAA`
const CLEAVE_OPTIONS = { date: true, datePattern: ['d', 'm', 'Y'], delimiter: DELIMITER }
const PICTO = {
  default: null,
  error: ExclamationMarkCircleBold,
  warning: ExclamationMarkTriangleBold,
}

const SentenceDateField = ({ onChange, pictoMessage, state = 'default', inputProps, value, ...props }) => {
  const handleChange = e => {
    const rawValue = e.target.value
    const dateISO = rawValue.split(DELIMITER).reverse().join('-')
    const dateValue = dateISO.length === 10 ? dateISO : null

    onChange(rawValue, dateValue, e)
  }

  return (
    <ThemeProvider theme={{ state }}>
      <S.Container {...props}>
        <S.Component>
          <S.Input
            options={CLEAVE_OPTIONS}
            placeholder={PLACEHOLDER}
            value={value}
            onChange={handleChange}
            {...inputProps}
          />
        </S.Component>
        {state !== 'default' && (
          <S.PictoContainer content={pictoMessage}>
            <S.Picto as={PICTO[state]} />
          </S.PictoContainer>
        )}
      </S.Container>
    </ThemeProvider>
  )
}

SentenceDateField.propTypes = {
  inputProps: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  pictoMessage: PropTypes.string,
  state: PropTypes.oneOf(['default', 'error', 'warning']),
  value: PropTypes.string.isRequired,
}

export default SentenceDateField
